import Vue from 'vue';
// @ts-ignore
import { VueHammer } from 'vue2-hammer';

Vue.use(VueHammer);
